<div [class.menu-hidden]="isHidden" (window:resize)="onResize()" class="menu-buttons-container">
  <div class="menu-buttons" (click)="onClickButton($event)" (mouseover)="onMouseOver($event)" (mouseout)="onMouseOut($event)">
    <ng-content></ng-content>
  </div>
  <div #menuStrike class="menu-strike"></div>
</div>
